module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAYAAABWk2cPAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4wwMCxwVVN3HYgAAAOFJREFUSMfN1r0NwjAQhuEX0iGQaCMxRGbIDhkh06TNFuyQGTxEBkAySmV+GhtZESAT8B0nXefoyY/z+UChVonr9kAD1EAFHIANMAEjYIABOAKnb2+qBHrAAbeEdn59uRRsAZuIzdv66z+qbiE2704aTIbbH4Oh23ebxmZC7avN1WcCQ/fP/kOXGXXeYe3RBigyB1HhnQdaCyVgHaOVEFrF2WuBrQB6BnYBvURPnbOuQBGgSej1TvE3HYXQMUaNEGpidBBCB7VEUs1etVNG5TxVmxzUZiS1aTDr3PuXE36WugM0QVgCWS28fAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/brush.png
// module id = dLrG
// module chunks = 1